<template>
    <div>
        <notifications position="top center" group="info" />

        <h1>Notifications</h1>

        <b-table
			striped
			hover
			:items="notifications"
			:fields="fields"
			tbody-tr-class="rowClass">
			<template v-slot:cell(uid)="data">
                <router-link
					:to="{ name: 'notification', params: { id: data.value } }"
					><i class="fas fa-external-link-alt"></i>
				</router-link>
				<b-button @click="delete_notif(data.value)" variant="link"><i class="fa fa-trash" style="color:red"></i></b-button>
			</template>
			<template v-slot:cell(active)="data">
				{{ data.value ? "oui" : "non"}}
			</template>
		</b-table>

		<h2>Nouveau</h2>

        <p>Type
        <b-select v-model="type" :options="['primary', 'success', 'danger', 'warning']"></b-select>
        </p>

        <p>Titre
            <b-input v-model="title"></b-input>
        </p>

        <p>Texte
        <b-textarea v-model="text"></b-textarea>
        </p>

        <p v-if="!client_uid">Canal
        <b-input v-model="dest"></b-input>
        </p>

        <p>Actif
        <b-checkbox v-model="active"></b-checkbox>
        </p>

        <br />

        <b-button @click="send">Ajouter</b-button>
    </div>

</template>

<script>
	import store from "../store.js";
	import notifications_services from "../services/notifications.js";

	export default {
		name: "views_notifications",
        components: {
        },
		data: function () {
			return {
                type: "danger",
                text: "",
                title: "",
                dest: "notification",
                active: false,
				notifications: [],
				client_uid: null,
				fields: [
					{
						key: "title",
						label: "Titre",
						sortable: false,
					},
					{
						key: "date",
						label: "Date",
						sortable: false,
					},
					{
						key: "active",
						label: "Actif",
					},
					{
						key: "uid",
						label: "",
						sortable: false,
					},
				]
			};
		},
		methods: {
            async send()
            {
                await notifications_services.post(this.type, this.title, this.text, this.client_uid || this.dest, this.active, this.client_uid);

                this.$notify({
					group: "info",
					title: "Notification enregistrée",
					type: "success",
                });
                
                this.notifications = await notifications_services.list(this.client_uid);
            },
            isAdmin: function() {
                return store.getters.isAdmin;
			},
			async delete_notif(id)
			{
				await notifications_services.delete(id);

				this.notifications = await notifications_services.list(this.client_uid);
			}
		},
		mounted: async function () {
			
			var path = this.$route.path;

			// (path)

			if (path == "/notifications_client")
			{
				if (store.state.user.rules && !store.state.user.rules.notifications) {
					this.$router.push({ name: "profile" });
				}
				this.client_uid = store.state.user.client_uid;
			}
			else
			{
				if (!this.isAdmin())
				{
					this.$router.push({ name: "profile" });
				}
				this.client_uid = null;
				this.fields.push(
				{
					key: "dest",
					label: "Canal",
					sortable: false,
				})
			}

			this.notifications = await notifications_services.list(this.client_uid);

            // this.resetActions();
		},
	};
</script>
